import type { ConceptDef } from '../types';

export const receptiveCategories: ConceptDef = {
  kind: 'tileMatch',
  id: 'receptive-categories',
  label: 'Receptive Categories',
  category: 'Receptive',
  description: 'Hear a category and tap a matching item.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'an animal', answer: '🐶 dog' },
      { say: 'a fruit', answer: '🍎 apple' },
      { say: 'a vehicle', answer: '🚗 car' },
      { say: 'a piece of clothing', answer: '👕 shirt' },
      { say: 'a tool', answer: '🔨 hammer' },
      { say: 'a piece of furniture', answer: '🪑 chair' },
    ],
  },
};
